@if (isVisible) {
    <ng-content></ng-content>
}